// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductsPage_container__kfZDV","metrics":"ProductsPage_metrics__sq58w"};